function rrAddVAT() {
  document.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function(el) {

    // Managed protective boots show their purchase-purpose price separately.
    if (el.closest('[data-tw-vat-managed], [data-tw-vat]')) return;

    // Don't add VAT more than once
    if (el.parentNode.querySelector('.rr-vat')) return;

    // Ignore crossed-out compare-at / old prices
    if (el.closest('.price__compare')) return;

    // Ignore hidden price elements
    if (el.offsetParent === null) return;

    var price = parseFloat(
      el.innerText.replace(/[^0-9.]/g, '')
    );

    // Ignore invalid or zero prices
    if (isNaN(price) || price <= 0) return;

    var vat = document.createElement('small');

    vat.className = 'rr-vat';

    vat.style.cssText =
      'display:block;font-size:13px;color:#555;margin-top:3px;';

    vat.innerText =
      'Ex. VAT: £' + (price / 1.2).toFixed(2);

    el.parentNode.appendChild(vat);

  });
}

window.addEventListener('load', rrAddVAT);

setTimeout(rrAddVAT, 2000);
setTimeout(rrAddVAT, 4000);